import { render } from "./RegisterOrUploadTemplate.vue?vue&type=template&id=7b4bc97f&scoped=true"
import script from "./RegisterOrUploadTemplate.vue?vue&type=script&lang=js"
export * from "./RegisterOrUploadTemplate.vue?vue&type=script&lang=js"

import "./RegisterOrUploadTemplate.vue?vue&type=style&index=0&id=7b4bc97f&scoped=true&lang=less"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4bc97f"]])

export default __exports__